import { useQuery } from '@tanstack/react-query'
import api from '@/services/api'
import type { WeeklyActivity } from '@/types/forklift'

interface WeeklyActivityParams {
  site_id?: string
  show_sim?: string // 'true' | 'false'
}

// 全フォークリフト×直近7日(当日除く)の実行シナリオ数を取得
// サーバー側で daily-stats を集計し DynamoDB にキャッシュ済み
export function useWeeklyActivity(params: WeeklyActivityParams = {}) {
  return useQuery({
    queryKey: ['weekly-activity', params],
    queryFn: async () => {
      const { data } = await api.get<WeeklyActivity>('/weekly-activity', {
        params,
      })
      return data
    },
    staleTime: 1000 * 60 * 5, // 5分
  })
}
